import React from "react";
import { useSearchParams } from "react-router-dom";

import { IgSelect, IgTypography } from "@intelligems/ig-theme";
import { MenuItem, SelectChangeEvent } from "@mui/material";
import { DashboardPageName } from "@src/api/types/dashboards";

const PAGE_LABELS: Record<DashboardPageName, string> = {
  overview: "Key Metrics",
  conversion: "Conversion",
  revenue: "Revenue",
  discounts: "Discounts",
  orders: "Order Distribution",
  profit: "Profit",
  shipping: "Shipping",
  subscriptions: "Subscriptions",
  productGroups: "Products",
  customMetrics: "Custom Metrics",
  dataReconciliation: "Data Reconciliation",
  // Additional pages (not typically shown in shared view)
  performance: "Performance",
  audience: "Audience",
  orderDistribution: "Order Distribution",
  visitors: "Visitors",
  impact: "Impact",
  singlePersonalizationTotal: "Personalization Total",
  timeSeries: "Time Series",
  personalizations: "Personalizations",
  statSig: "Statistical Significance",
  alwaysOnCumulative: "Always On Cumulative",
  goals: "Goals",
  postTestMetrics: "Post-Test Metrics",
  checkoutUpsell: "Checkout Upsell",
  onsiteUpsell: "Onsite Upsell",
};

interface SharePageSelectProps {
  currentPage: DashboardPageName;
  availablePages: DashboardPageName[];
}

export const SharePageSelect = ({
  currentPage,
  availablePages,
}: SharePageSelectProps) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const handleChange = (e: SelectChangeEvent) => {
    const newPage = e.target.value as DashboardPageName;

    // Update URL query param while preserving share_token
    searchParams.set("page", newPage);
    setSearchParams(searchParams);

    // Scroll to top
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <IgSelect
      labelId="share-page-select-label"
      id="share-page-select"
      displayEmpty
      value={currentPage}
      onChange={handleChange}
      renderValue={(page: DashboardPageName) => (
        <IgTypography>
          View:{" "}
          <IgTypography sx={{ fontWeight: 600 }}>
            {PAGE_LABELS[page]}
          </IgTypography>
        </IgTypography>
      )}
    >
      {availablePages.map((page) => (
        <MenuItem key={page} value={page} sx={{ fontSize: "14px" }}>
          {PAGE_LABELS[page]}
        </MenuItem>
      ))}
    </IgSelect>
  );
};
